import React, { useState, useEffect, useRef, useCallback } from 'react';

import Card from "../Card/Card";
import Popup from '../../components/Popup/Popup.jsx';

import { colors as c } from "../../styles/variables.js"
import { Medium, Small } from "../../styles/typography/typography";

import {
    HeaderSt,
    DescriptionContainerSt,
    ContainerSt,
    ContentSt,
    CardsContainerSt,
    CarouselSt,
    ArrowSt,
    ButtonSt,
    ButtonStPadding,
    LinkSt
} from './style.js';
import {
    PopupFrameStyled
} from '../Popup/style.js';

import i18n from "i18next";

const Carousel = ({ cards, type, title, link, render, description }) => {
    const [maxRight, setMaxRight] = useState(0);
    // margin-left у CarouselSt - за чет которого осуществляется листание карусели
    const [marginCount, setMarginCount] = useState(0);
    const [rightButtonDisplay, setRightButtonDisplay] = useState(false);
    const [leftButtonDisplay, setLeftButtonDisplay] = useState(false);
    // контроль закрытия второго описания
    const [closeAllCardsDiscription, setCloseAllCardsDiscription] = useState(false);
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const [trailer, setTrailer] = useState(undefined);

    // ref - для получения ширины контейнара карусели
    const cardsContainerSt = useRef(null);

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    const handleClick = (evt, id) => {
        evt.preventDefault()
        setPopupIsOpen((prev) => !prev);
        setTrailer(id);
    };

    // при открытии второго описания закрываем первое
    const _closeAllCardsDiscription = useCallback(() => {
        setCloseAllCardsDiscription(true);
        timers.current.push(setTimeout(() => {
            setCloseAllCardsDiscription(false);
        }, 50));
    }, []);

    // Движение карусели ВПРАВО
    const carouselMoveRight = () => {
        let newMarginCount = marginCount + 1;
        if (cards.length - newMarginCount === maxRight) {
            setMarginCount(newMarginCount);
            setRightButtonDisplay(false);
            setLeftButtonDisplay(true);
        }
        else {
            setMarginCount(newMarginCount);
            setLeftButtonDisplay(true);
        }
    };

    // При открытии описания в крайней с права карте, происходит движение карусели вправо
    const _openDecrStepRight = (indexCard) => {
        if (indexCard === marginCount + maxRight) {
            carouselMoveRight();
        }
    };

    // Движение карусели ВЛЕВО
    const carouselMoveLeft = () => {
        let newMarginCount = marginCount - 1;
        if (newMarginCount === 0) {
            setMarginCount(newMarginCount);
            setLeftButtonDisplay(false);
            setRightButtonDisplay(true);
        }
        else {
            setMarginCount(newMarginCount);
            setRightButtonDisplay(true);
        }
    };

    // Движение карусели СВАЙПОМ
    const swipeZeroDot = useRef(0);
    const swipeBreak = useRef(true);

    // получение первой точки свайпа
    const swipeSlide = (e) => {
        swipeZeroDot.current = e.changedTouches[0].pageX;
    };

    //отработка горизонтального свайпа
    const swipeSlideEnd = (e) => {
        if (swipeBreak.current) {
            swipeBreak.current = false;
            let finalDot = swipeZeroDot.current - e.changedTouches[0].pageX;
            if (finalDot > 1 && rightButtonDisplay) {
                carouselMoveRight();
            }
            else if (finalDot < -1 && leftButtonDisplay) {
                carouselMoveLeft();
            }
            timers.current.push(setTimeout(() => { swipeBreak.current = true }, 300));
        }
    };

    // componentDidMount: показываем правую стрелку
    useEffect(() => {
        const timer = setTimeout(() => {
            if (cardsContainerSt.current) {
                if (cardsContainerSt.current.offsetWidth > 943 && cards.length > 5) {
                    setRightButtonDisplay(true);
                    setMaxRight(5);
                }
                else if (cardsContainerSt.current.offsetWidth < 944 && cardsContainerSt.current.offsetWidth > 727 && cards.length > 4) {
                    setRightButtonDisplay(true);
                    setMaxRight(4);
                }
                else if (cardsContainerSt.current.offsetWidth < 728 && cards.length > 2) {
                    setRightButtonDisplay(true);
                    setMaxRight(2);
                }
            }
        }, 1000);

        return () => { clearTimeout(timer) };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Передаем в allCards все карты полученные с сервера по запросу.
    // Если карта последняя в ряду, то descriptionOpenLeft={true} - для открытия описания в лево
    // и для нее не задаются дополнительная функция (_openDecrStepRight) для перелистывания слайдера одновременно с открытием описания проекта
    const allCards = cards.map((item, i) => {
        if (i === cards.length - 1 && cards.length > 1) {
            return (
                <Card {...item} key={i + 1} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={true} _closeAllCardsDiscription={_closeAllCardsDiscription} closeAllCardsDiscription={closeAllCardsDiscription} handleClick={(evt, id) => handleClick(evt, id)} />
            )
        }
        else {
            return (
                <Card {...item} key={i + 1} type={type} zIndexCard={cards.length - i} discriptionOpenLeft={false} _closeAllCardsDiscription={_closeAllCardsDiscription} closeAllCardsDiscription={closeAllCardsDiscription} handleClick={(evt, id) => handleClick(evt, id)} _openDecrStepRight={(index) => _openDecrStepRight(index)} index={i + 1} />
            )
        }
    })

    return (
        <>
            <ContainerSt>
                <HeaderSt>
                    {title}
                    {link &&
                        <LinkSt to={link} onClick={() => { render && render(); localStorage.setItem('filterStart', title) }}>
                            <Small uppercase bold color={c.blue}>{i18n.t(`home.see_all`)}</Small>
                        </LinkSt>
                    }
                </HeaderSt>
                <DescriptionContainerSt className="description">
                    <Medium>{description}</Medium>
                </DescriptionContainerSt>
                <ContentSt>
                    <CardsContainerSt ref={cardsContainerSt}>
                        <CarouselSt widthEl={cards.length} marginCount={marginCount} onTouchStart={(e) => swipeSlide(e)} onTouchMove={(e) => swipeSlideEnd(e)}>
                            {allCards}
                        </CarouselSt>
                    </CardsContainerSt>
                    {leftButtonDisplay && <ButtonSt side="left" onClick={() => carouselMoveLeft()}>
                        <ButtonStPadding></ButtonStPadding>
                        <ArrowSt width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.668 3.79967L6.36658 13.9997L16.668 24.1997L13.4966 27.333L0.00131342 13.9997L13.4966 0.66634L16.668 3.79967Z" fill="white" />
                        </ArrowSt>
                    </ButtonSt>}
                    {rightButtonDisplay && <ButtonSt side="right" onClick={() => carouselMoveRight()}>
                        <ButtonStPadding></ButtonStPadding>
                        <ArrowSt width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.332027 24.2003L10.6334 14.0003L0.332031 3.80032L3.50342 0.666993L16.9987 14.0003L3.50341 27.3337L0.332027 24.2003Z" fill="white" />
                        </ArrowSt>
                    </ButtonSt>}
                </ContentSt>
            </ContainerSt>

            {/*попап с видео*/}
            {popupIsOpen
                ? <Popup
                    handleClick={handleClick} >
                    {/* key пересоздаёт iframe вместо смены src, чтобы не добавлять запись в историю браузера */}
                    <PopupFrameStyled key={trailer} src={trailer} />
                </Popup>
                : null
            }
        </>
    );
};

export default Carousel;
